<template>
  <div v-if="show" class="receipt-overlay" @click.self="$emit('close')">
    <div class="receipt-wrapper">

      <!-- Tugmalar (chop qilishda yashiriladi) -->
      <div class="receipt-actions no-print">
        <button class="btn-print" @click="printReceipt">
          <b-icon icon="printer-fill"></b-icon> Chop etish
        </button>
        <button class="btn-close-modal" @click="$emit('close')">
          <b-icon icon="x-lg"></b-icon> Yopish
        </button>
      </div>

      <!-- CHek -->
      <div class="receipt" id="sale-receipt">

        <!-- Logo + Firma header -->
        <div class="receipt-header">
          <img v-if="logoUrl" :src="logoUrl" class="receipt-logo" alt="logo" />
          <div class="firm-name">{{ firmName }}</div>
          <div v-if="phone" class="firm-phone">Tel: {{ phone }}</div>
          <div class="receipt-date">{{ receiptDate }}</div>
        </div>

        <div class="receipt-divider"></div>

        <!-- Mijoz, Usta, Mashina -->
        <div class="receipt-info">
          <div class="info-row">
            <span class="info-label">Mijoz:</span>
            <span class="info-value">{{ clientName }}</span>
          </div>
          <div v-if="masterName" class="info-row">
            <span class="info-label">Usta:</span>
            <span class="info-value">{{ masterName }}</span>
          </div>
          <div v-if="carNumber" class="info-row">
            <span class="info-label">Mashina:</span>
            <span class="info-value">{{ carNumber }}</span>
          </div>
        </div>

        <div class="receipt-divider"></div>

        <!-- Jadval sarlavha -->
        <div class="item-header">
          <span class="ih-name">Nomi</span>
          <span class="ih-qty">Soni</span>
          <span class="ih-price">Narxi</span>
          <span class="ih-total">Summa</span>
        </div>
        <div class="receipt-divider-solid"></div>

        <!-- Xizmatlar va mahsulotlar -->
        <div v-for="(item, i) in receiptItems" :key="i" class="item-row">
          <span class="ir-name">{{ item.name }}</span>
          <span class="ir-qty">{{ item.qty }}</span>
          <span class="ir-price">{{ item.nameOnly ? '' : fmtPrice(item.unitPrice, item.dollarUnitPrice) }}</span>
          <span class="ir-total">{{ item.nameOnly ? '' : fmtPrice(item.total, item.dollarTotal) }}</span>
        </div>

        <div class="receipt-divider"></div>

        <!-- Hisob-kitob -->
        <div class="calc-section">
          <div v-if="skidka > 0" class="calc-row calc-discount">
            <span>Chegirma:</span>
            <span>- {{ fmtPrice(skidka) }}</span>
          </div>
          <div class="calc-row calc-total">
            <span>JAMI:</span>
            <span>{{ fmtPrice(totalSum) }}</span>
          </div>
          <div v-if="refundMoney > 0" class="calc-row calc-discount">
            <span>Qaytim:</span>
            <span>{{ fmt(refundMoney) }} so'm</span>
          </div>

          <!-- TO'LOV TURLARI BREAKDOWN -->
          <div v-if="paymentRows.length > 0" class="pay-block">
            <div class="pay-title">To'langan:</div>
            <div v-for="(p, i) in paymentRows" :key="i" class="calc-row pay-row">
              <span>{{ p.name }}:</span>
              <span>
                <template v-if="p.isDollar">$ {{ fmt(p.summa) }}</template>
                <template v-else>{{ fmtPrice(p.summa) }}</template>
                <small v-if="p.isDollar && !isDollarMode"> ($ ≈ {{ fmt(p.somEq) }})</small>
                <small v-if="!p.isDollar && isDollarMode"> ({{ fmt(p.summa) }} so'm)</small>
              </span>
            </div>
            <div class="calc-row pay-total">
              <span>Jami to'landi:</span>
              <span>{{ fmtPrice(totalPaidSom) }}</span>
            </div>
          </div>

          <!-- Eski legacy ko'rsatkichlar (agar pay_table bo'sh) -->
          <template v-else>
            <div v-if="cashSumma > 0" class="calc-row">
              <span>Naqd:</span><span>{{ fmtPrice(cashSumma) }}</span>
            </div>
            <div v-if="plasticSumma > 0" class="calc-row">
              <span>Plastik:</span><span>{{ fmtPrice(plasticSumma) }}</span>
            </div>
            <div v-if="shotSumma > 0" class="calc-row">
              <span>Hisob:</span><span>{{ fmtPrice(shotSumma) }}</span>
            </div>
          </template>
        </div>

        <!-- ============ QARZ BLOKI ============ -->
        <div v-if="hasDebt" class="receipt-divider"></div>
        <div v-if="hasDebt" class="debt-block">
          <div class="debt-title">QARZ HISOBI</div>
          <!-- So'mdagi qarz -->
          <template v-if="hasSomDebt">
            <div class="calc-row" v-if="Math.abs(prevDebt) > 0.01">
              <span>Savdodan oldingi qarzi:</span>
              <span :class="prevDebt > 0 ? 'debt-pos' : 'debt-neg'">{{ fmt(prevDebt) }}</span>
            </div>
            <div class="calc-row" v-if="addedDebtSom > 0">
              <span>Qo'shilgan qarz:</span>
              <span class="debt-pos">+ {{ fmt(addedDebtSom) }}</span>
            </div>
            <div class="calc-row debt-total">
              <span>JAMI QARZ:</span>
              <span :class="totalDebt > 0 ? 'debt-pos' : 'debt-neg'">{{ fmt(totalDebt) }}</span>
            </div>
          </template>
          <!-- Dollardagi qarz (so'mga aylantirilmaydi) -->
          <template v-if="hasDollarDebt">
            <div class="calc-row" v-if="Math.abs(prevDebtDollar) > 0.001">
              <span>Savdodan oldingi qarzi ($):</span>
              <span :class="prevDebtDollar > 0 ? 'debt-pos' : 'debt-neg'">$ {{ fmtUsd(prevDebtDollar) }}</span>
            </div>
            <div class="calc-row" v-if="addedDebtDollar > 0">
              <span>Qo'shilgan qarz ($):</span>
              <span class="debt-pos">+ $ {{ fmtUsd(addedDebtDollar) }}</span>
            </div>
            <div class="calc-row debt-total">
              <span>JAMI QARZ ($):</span>
              <span :class="totalDebtDollar > 0 ? 'debt-pos' : 'debt-neg'">$ {{ fmtUsd(totalDebtDollar) }}</span>
            </div>
          </template>
          <div v-if="nasiyaDateStr" class="calc-row debt-due">
            <span>Muddat:</span>
            <span><b>{{ nasiyaDateStr }}</b></span>
          </div>
        </div>

        <div class="receipt-divider"></div>

        <!-- Footer -->
        <div class="receipt-footer">
          <div v-if="checkWord" class="check-word">{{ checkWord }}</div>
          <div class="thank-you">Xaridingiz uchun rahmat!</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleReceiptModal',
  props: {
    show:        { type: Boolean, default: false },
    firmName:    { type: String,  default: '' },
    phone:       { type: String,  default: '' },
    checkWord:   { type: String,  default: '' },
    logoUrl:     { type: String,  default: '' },
    clientName:  { type: String,  default: "NOMA'LUM" },
    masterName:  { type: String,  default: '' },
    carNumber:   { type: String,  default: '' },
    cart:        { type: Array,   default: () => [] },
    totalSum:    { type: Number,  default: 0 },
    skidka:      { type: Number,  default: 0 },
    cashSumma:   { type: Number,  default: 0 },
    plasticSumma:{ type: Number,  default: 0 },
    shotSumma:   { type: Number,  default: 0 },
    // YANGI: N-ta to'lov turi
    payTable:    { type: Array,   default: () => [] },          // [{pay_type_id, summa}]
    paytypes:    { type: Array,   default: () => [] },          // [{id, name}]
    dollarRate:  { type: [Number, String], default: 1 },
    currencyMode:{ type: String, default: 'som' },
    refundMoney: { type: Number, default: 0 },
    // YANGI: qarz bloki
    prevDebt:    { type: Number,  default: 0 },                 // savdodan oldingi qarz (so'm)
    prevDebtDollar: { type: Number, default: 0 },               // savdodan oldingi qarz ($)
    nasiyaDate:  { type: [String, Number], default: '' },       // muddati (date str yoki unix)
  },
  computed: {
    receiptDate() {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const yyyy = now.getFullYear();
      const hh = String(now.getHours()).padStart(2, '0');
      const min = String(now.getMinutes()).padStart(2, '0');
      return `${dd}.${mm}.${yyyy}  ${hh}:${min}`;
    },
    isDollarMode() {
      return this.currencyMode === 'dollar';
    },
    receiptItems() {
      const rate = parseFloat(this.dollarRate) || 1;
      // Paket TURI (package_type — "Peredelka zapchasti bilan", "Tayyor yumshatish")
      // shu ro'yxatlarda bo'lsa, ehtiyot qism (material) qiymati alohida qator
      // sifatida chiqmaydi — xizmat nomi turgan qatorning summasiga qo'shib yuboriladi.
      // MERGE_HIDE — material qatori butunlay yashiriladi (nomi ham chiqmaydi).
      // MERGE_SHOW_NAME — material nomi pastda chiqadi, lekin narx/summa ustunlari bo'sh qoladi.
      const MERGE_HIDE = ['PEREDELKA ZAPCHASTI BILAN'];
      const MERGE_SHOW_NAME = ['TAYYOR YUMSHATISH'];
      const norm = s => (s || '').toString().trim().toUpperCase();

      const serviceById = new Map();
      this.cart.forEach(it => { if (it.type === 'service') serviceById.set(it.id, it); });

      // Har bir "qo'shiladigan" xizmatga tegishli materiallar summasini oldindan yig'ib olamiz
      const mergedSom = new Map();
      const mergedDollar = new Map();
      this.cart.forEach(it => {
        if (it.type !== 'product' || it.from_service == null) return;
        const parent = serviceById.get(it.from_service);
        const name = norm(parent && parent.package_type_name);
        if (!MERGE_HIDE.includes(name) && !MERGE_SHOW_NAME.includes(name)) return;
        const som = Number(it.price || 0) * Number(it.qty || 0);
        const dollarUnit = Number(it.dollar_price || 0) > 0 ? Number(it.dollar_price) : Number(it.price || 0) / rate;
        const dollar = dollarUnit * Number(it.qty || 0);
        mergedSom.set(it.from_service, (mergedSom.get(it.from_service) || 0) + som);
        mergedDollar.set(it.from_service, (mergedDollar.get(it.from_service) || 0) + dollar);
      });

      const rows = [];
      this.cart.forEach(item => {
        if (item.type === 'service') {
          const qty = Number(item.qty) || 1;
          const baseUnitPrice = Number(item.labor_price || 0) + Number(item.redo_price || 0);
          const extraSom = mergedSom.get(item.id) || 0;
          const extraDollar = mergedDollar.get(item.id) || 0;
          const total = baseUnitPrice * qty + extraSom;
          const dollarTotal = (baseUnitPrice / rate) * qty + extraDollar;
          // Narxi ustuni Summa bilan mos kelishi uchun (Narxi x Soni = Summa) —
          // qo'shilgan ehtiyot qism qiymati birlik narxiga ham taqsimlab qo'shiladi.
          rows.push({
            name: item.name, qty,
            unitPrice: total / qty, total,
            dollarUnitPrice: dollarTotal / qty, dollarTotal,
          });
          return;
        }
        if (item.type === 'product' && item.from_service != null) {
          const parent = serviceById.get(item.from_service);
          const name = norm(parent && parent.package_type_name);
          if (MERGE_HIDE.includes(name)) return; // qator butunlay chiqmaydi
          if (MERGE_SHOW_NAME.includes(name)) {
            rows.push({ name: item.name, qty: item.qty, nameOnly: true });
            return;
          }
        }
        const unitPrice = Number(item.price || 0);
        const dollarUnitPrice = Number(item.dollar_price || 0) > 0 ? Number(item.dollar_price) : unitPrice / rate;
        rows.push({
          name: item.name, qty: item.qty, unitPrice, total: unitPrice * item.qty,
          dollarUnitPrice, dollarTotal: dollarUnitPrice * item.qty,
        });
      });
      return rows;
    },
    // To'lov turlarini ko'rinish uchun tayyorlash (nomlar + dollar ekvivalenti)
    paymentRows() {
      if (!Array.isArray(this.payTable) || this.payTable.length === 0) return [];
      const rate = parseFloat(this.dollarRate) || 1;
      return this.payTable
        .filter(p => p && parseFloat(p.summa) > 0)
        .map(p => {
          const id = parseInt(p.pay_type_id);
          const ptName = this.payTypeName(id);
          const isDollar = id === 3;
          const summa = parseFloat(p.summa) || 0;
          return {
            id, name: ptName, summa, isDollar,
            somEq: isDollar ? summa * rate : summa,
          };
        });
    },
    totalPaidSom() {
      return this.paymentRows.reduce((acc, p) => acc + (p.somEq || 0), 0);
    },
    // Qarz bloki hisobi
    addedDebt() {
      // pay_table dan kelgan to'lov | yo'q bo'lsa cashSumma+plasticSumma+shotSumma
      const paid = this.paymentRows.length > 0
        ? this.totalPaidSom
        : (Number(this.cashSumma) + Number(this.plasticSumma) + Number(this.shotSumma));
      const diff = Number(this.totalSum) - paid;
      return diff > 0 ? diff : 0;
    },
    // Dollar rejimidagi savdoda qolgan qarz dollarda yoziladi (backend: qarz_dollar = qarz / kurs),
    // shuning uchun chekda ham so'mga aylantirmasdan $ da qo'shiladi.
    addedDebtSom() {
      return this.isDollarMode ? 0 : this.addedDebt;
    },
    addedDebtDollar() {
      if (!this.isDollarMode) return 0;
      const rate = parseFloat(this.dollarRate) || 1;
      return this.addedDebt / rate;
    },
    totalDebt() {
      return Number(this.prevDebt || 0) + this.addedDebtSom;
    },
    totalDebtDollar() {
      return Number(this.prevDebtDollar || 0) + this.addedDebtDollar;
    },
    hasSomDebt() {
      return Math.abs(this.prevDebt || 0) > 0.01 || this.addedDebtSom > 0;
    },
    hasDollarDebt() {
      return Math.abs(this.prevDebtDollar || 0) > 0.001 || this.addedDebtDollar > 0;
    },
    hasDebt() {
      return this.hasSomDebt || this.hasDollarDebt;
    },
    nasiyaDateStr() {
      if (!this.nasiyaDate) return '';
      // unix timestamp bo'lsa sana ga aylantirish
      if (typeof this.nasiyaDate === 'number' || /^\d+$/.test(String(this.nasiyaDate))) {
        const ts = Number(this.nasiyaDate);
        if (!ts) return '';
        return new Date(ts * 1000).toLocaleDateString('ru-RU');
      }
      // 'YYYY-MM-DD' bo'lsa shu format'da DD.MM.YYYY ga
      const d = new Date(this.nasiyaDate);
      if (isNaN(d.getTime())) return String(this.nasiyaDate);
      return d.toLocaleDateString('ru-RU');
    },
  },
  methods: {
    fmt(val) {
      return Number(val || 0).toLocaleString('uz-UZ');
    },
    fmtUsd(val) {
      return Number(val || 0).toFixed(2);
    },
    // Savdo dollarda amalga oshirilgan bo'lsa ($ va sentgacha), aks holda so'mda ko'rsatadi
    fmtPrice(som, dollar = 0) {
      if (this.isDollarMode) {
        const rate = parseFloat(this.dollarRate) || 1;
        const value = Number(dollar) > 0 ? Number(dollar) : Number(som || 0) / rate;
        return `$ ${value.toFixed(2)}`;
      }
      return this.fmt(som);
    },
    payTypeName(id) {
      const def = { 1: 'Naqd', 2: 'Plastik', 3: 'Dollar', 4: 'Hisob' };
      const found = (this.paytypes || []).find(p => parseInt(p.id) === parseInt(id));
      if (found && found.name) return found.name;
      return def[id] || `Tur #${id}`;
    },
    printReceipt() {
      const el = document.getElementById('sale-receipt');
      const printWindow = window.open('', '_blank', 'width=320,height=600');
      printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Chek</title>
<style>
  @page {
    size: 80mm auto;
    margin: 0;
  }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    width: 80mm;
    font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #000;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    padding: 3mm;
  }
  .receipt-logo {
    display: block;
    max-width: 60mm;
    max-height: 22mm;
    margin: 0 auto 2mm;
    object-fit: contain;
  }
  .receipt-header { text-align: center; margin-bottom: 2mm; }
  .firm-name { font-size: 16px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; }
  .firm-phone { font-size: 11px; margin-top: 1mm; }
  .receipt-date { font-size: 11px; color: #000; margin-top: 1mm; }
  .receipt-divider { border-top: 3px dashed #000; margin: 2mm 0; }
  .receipt-divider-solid { border-top: 3px solid #000; margin: 1mm 0; }
  .receipt-info { margin: 1mm 0; }
  .info-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.5; }
  .info-label { color: #000; }
  .info-value { font-weight: 700; text-align: right; max-width: 55%; word-break: break-word; }
  .item-header {
    display: flex; font-size: 10px; font-weight: 700; padding: 0.5mm 0;
  }
  .ih-name { flex: 1; }
  .ih-qty { width: 8mm; text-align: center; }
  .ih-price { width: 14mm; text-align: right; }
  .ih-total { width: 16mm; text-align: right; }
  .item-row {
    display: flex; font-size: 11px; line-height: 1.45; border-bottom: 3px solid #000;
    padding: 1.5mm 0;
    align-items: flex-start;
  }
  .ir-name { flex: 1; word-break: break-word; overflow-wrap: anywhere; white-space: normal; padding-right: 2mm; }
  .ir-qty { width: 8mm; text-align: center; }
  .ir-price { width: 14mm; text-align: right; font-size: 10px; }
  .ir-total { width: 16mm; text-align: right; font-weight: 700; }
  .calc-section { margin: 2mm 0; }
  .calc-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.6; }
  .calc-total { font-size: 15px; font-weight: 900; border-top: 2px solid #000; border-bottom: 2px solid #000; padding: 1mm 0; margin: 1mm 0; }
  .calc-discount { color: #000; }
  .pay-block { margin-top: 1.5mm; }
  .pay-title { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; padding: 0.5mm 0; }
  .pay-row { padding-left: 2mm; }
  .pay-row small { font-size: 9px; opacity: 0.8; }
  .pay-total { font-weight: 800; border-top: 1px dotted #000; padding-top: 0.5mm; margin-top: 0.5mm; }
  .debt-block { margin-top: 1mm; padding: 1.5mm; border: 1px solid #000; border-radius: 1mm; }
  .debt-title { font-size: 11px; font-weight: 900; text-align: center; text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 1mm; }
  .debt-total { font-size: 13px; font-weight: 900; border-top: 1px solid #000; padding-top: 1mm; margin-top: 0.5mm; }
  .debt-due { margin-top: 0.5mm; font-size: 11px; }
  .debt-pos { font-weight: 800; }
  .debt-neg { font-weight: 800; }
  .receipt-footer { text-align: center; margin-top: 2mm; padding-bottom: 3mm; }
  .check-word { font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
  .thank-you { font-size: 11px; color: #000; margin-top: 1mm; }
</style>
</head>
<body>${el.innerHTML}</body>
</html>`);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 400);
    },
  },
};
</script>

<style scoped>
/* === Overlay === */
.receipt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.receipt-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-height: 95vh;
  overflow-y: auto;
}

/* === Action buttons === */
.receipt-actions {
  display: flex;
  gap: 10px;
}
.btn-print {
  background: #10b981;
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}
.btn-close-modal {
  background: white;
  color: #64748b;
  border: 1px solid #e2e8f0;
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

/* === Receipt preview (80mm simulated) === */
.receipt {
  background: white;
  width: 302px; /* ~80mm at screen */
  padding: 12px;
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #000;
  border-radius: 2px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}

/* Logo */
.receipt-logo {
  display: block;
  max-width: 220px;
  max-height: 80px;
  margin: 0 auto 6px;
  object-fit: contain;
}

/* Header */
.receipt-header {
  text-align: center;
  margin-bottom: 6px;
}
.firm-name {
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.firm-phone {
  font-size: 11px;
  margin-top: 2px;
}
.receipt-date {
  font-size: 11px;
  color: #000;
  margin-top: 2px;
}

/* Dividers */
.receipt-divider {
  border-top: 3px dashed #000;
  margin: 6px 0;
}
.receipt-divider-solid {
  border-top: 3px solid #000;
  margin: 3px 0;
}

/* Info section */
.receipt-info {
  margin: 4px 0;
}
.info-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 1.5;
}
.info-label {
  color: #000;
}
.info-value {
  font-weight: 700;
  text-align: right;
  max-width: 55%;
  word-break: break-word;
}

/* Items table */
.item-header {
  display: flex;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 0;
}
.ih-name { flex: 1; }
.ih-qty { width: 30px; text-align: center; }
.ih-price { width: 52px; text-align: right; }
.ih-total { width: 60px; text-align: right; }

.item-row {
  display: flex;
  font-size: 11px;
  line-height: 1.6;
  border-bottom: 3px solid #000;
  padding: 5px 0;
  align-items: flex-start;
}
.ir-name {
  flex: 1;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
  padding-right: 4px;
}
.ir-qty { width: 30px; text-align: center; }
.ir-price { width: 52px; text-align: right; font-size: 10px; }
.ir-total { width: 60px; text-align: right; font-weight: 700; }

/* Calc section */
.calc-section {
  margin: 6px 0;
}
.calc-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 1.6;
}
.calc-total {
  font-size: 15px;
  font-weight: 900;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  padding: 3px 0;
  margin: 3px 0;
}
.calc-discount {
  color: #000;
}

/* To'lov breakdown */
.pay-block { margin-top: 6px; }
.pay-title {
  font-size: 10px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.5px; padding: 2px 0; color: #000;
}
.pay-row { padding-left: 8px; font-size: 12px; }
.pay-row small { font-size: 10px; opacity: 0.75; }
.pay-total {
  font-weight: 800; border-top: 1px dotted #000;
  padding-top: 2px; margin-top: 3px;
}

/* Qarz bloki */
.debt-block {
  margin-top: 6px; padding: 6px;
  border: 1.5px solid #000; border-radius: 4px;
}
.debt-title {
  font-size: 11px; font-weight: 900; text-align: center;
  text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 4px;
}
.debt-total {
  font-size: 13px; font-weight: 900;
  border-top: 1px solid #000; padding-top: 3px; margin-top: 2px;
}
.debt-due { margin-top: 2px; font-size: 11px; }
.debt-pos { font-weight: 800; color: #000; }
.debt-neg { font-weight: 800; color: #000; }

/* Footer */
.receipt-footer {
  text-align: center;
  margin-top: 6px;
}
.check-word {
  font-weight: 800;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.thank-you {
  font-size: 11px;
  color: #000;
  margin-top: 3px;
}

/* === Print media === */
@media print {
  .no-print { display: none !important; }
  .receipt-overlay {
    position: static;
    background: none;
  }
  .receipt {
    width: 80mm;
    box-shadow: none;
    padding: 3mm;
    font-size: 12px;
  }
  .receipt-logo {
    max-width: 60mm;
    max-height: 22mm;
  }
}
</style>
